const identities = new WeakMap<object, number>();
let nextIdentity = 0;

/** Sitzungs-/Berechtigungsrevision ohne Token oder andere Authdaten im Query-Key. */
export function authQueryScope(api: object, info: object | null): readonly number[] {
  const identity = (value: object) => {
    let id = identities.get(value);
    if (id === undefined) {
      id = ++nextIdentity;
      identities.set(value, id);
    }
    return id;
  };
  return [identity(api), info ? identity(info) : 0];
}
